import React, { Component } from 'react';
import { translate } from 'react-i18next';
import { AppView, ListSection, ListItem } from 'medua-components';
import { history } from '../../../../store';

/* eslint-disable */
@translate(['account', 'languages'])
export default class AccountSettingsLanguage extends Component {

  constructor(props) {
    super(props);
    this.state = {
      error: '',
      language: this.props.i18n.language
    };

    this.toggle = this.toggle.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ language: nextProps.i18n.language })
  }

  handleBack() {
    history.push('/account/settings')
  }

  handleChangeLanguage(lng) {
    const { i18n } = this.props
    i18n.changeLanguage(lng)
  }

  renderLanguageChoice(code) {
    return (
      <ListItem
        key={ code }
        title={ this.props.t(`languages:${code}`) }
        handleClick={ () => this.handleChangeLanguage(code) } />
    )
  }

  toggle(type, value) {
    if (value) {
      this.setState({ [type]: false });
    } else {
      this.setState({ [type]: true });
    }
  }

  render() {
    const languages =['de', 'en']
    return (
      <AppView
        color="dark"
        title={ this.props.t('account:settings.language.title') }
        headerActionLeft={[
          { key: 1, icon: 'arrow-left', action: this.handleBack }
        ]}>
        <ListSection margin>
          { languages.map(code => this.renderLanguageChoice(code)) }
        </ListSection>
      </AppView>
    );
  }
}



// WEBPACK FOOTER //
// ./src/routes/account/settings/language/index.jsx